import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined';
import DataSummaryTotal from './DataSummaryTotal';
import ProvinciasChart from './ProvinciasChart';
import MunicipiosChart from './MunicipiosChart';
import TelefonosChart from './TelefonosChart';
import EmailsChart from './EmailsChart';
import DireccionesChart from './DireccionesChart';
import HealthAnalyzer from './HealthAnalyzer';
import ManIcon from '@mui/icons-material/Man';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import WomanIcon from '@mui/icons-material/Woman';
import StorageIcon from '@mui/icons-material/Storage';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntityPermissions from '../components/EntityPermissions';
import ComunidadesAutonomasChart from '../Chart/ComunidadesAutonomas/ComunidadesAutonomasChart';
import ComunidadesAutonomasSexoChart from '../Chart/ComunidadesAutonomas/ComunidadesAutonomasSexoChart';
import ProvinciasChartSexo from '../Chart/Provincias/ProvinciasChartSexo';
import Common from '../utilities/common';
import ComunidadesAutonomasField from '../Chart/ComunidadesAutonomas/ComunidadesAutonomasField';
import ComunidadesAutonomasCups from '../Chart/ComunidadesAutonomas/ComunidadesAutonomasCups';
import $ from "jquery";

type State = {
    total: number
}

export default class DataSummary extends React.Component<{}, State> {
    state: State = {
        total: 0
    };

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        const { total } = this.state;
        return (
            <SecurityTrimmer entity={Entity.Dashboard} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido'>
                <Layout>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <StackedBarChartOutlinedIcon className='mainIcon' />
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                    Análisis
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        {
                            total > 0 && (
                                <>
                                    <HealthAnalyzer />
                                        <Grid container spacing={3} marginBottom={'20px'}>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='' title='Total' icon={<StorageIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='men' title='Hombres' icon={<ManIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='women' title='Mujeres' icon={<WomanIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='fechaNacimiento' title='Fechas de nacimiento' icon={<CakeOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='telefonos' title='Teléfonos' icon={<LocalPhoneOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='emails' title='Emails' icon={<AlternateEmailOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='direcciones' title='Nombres de vía' icon={<SignpostOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='tiposVia' title='Tipos de vía' icon={<TrafficOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='municipios' title='Municipios' icon={<HolidayVillageOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='provincias' title='Provincias' icon={<LocationCityOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='cupsLuz' title='CUPS Luz' icon={<LightOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <DataSummaryTotal field='cupsLuz' title='CUPS Gas' icon={<LocalFireDepartmentOutlinedIcon style={{ fontSize: '36px', opacity: '.5' }} />} />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3} marginBottom={'20px'}>
                                            <Grid item xs={6}>
                                                <ComunidadesAutonomasChart />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <ComunidadesAutonomasSexoChart />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='telefono' title='Teléfonos por comunidades autónomas' label='Teléfonos' />
                                            </Grid>
                                            {/*
                                                <Grid item xs={12}>
                                                    <ComunidadesAutonomasField field='email' label={'Emails'} title='Emails por comunidades autónomas' />
                                                </Grid>
                                                <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar}>
                                                    <Grid item xs={12}>
                                                        <ComunidadesAutonomasField field='ip' title='IPs por comunidades autónomas' label='IPs' />
                                                    </Grid>
                                                </SecurityTrimmer>
                                            */}
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasCups />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='TipoVia' label={'Tipos de vía'} title='Tipos de vía por comunidades autónomas' />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='NombreVia' label={'Nombres de vía'} title='Nombres de vía por comunidades autónomas' />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='NumeroVia' label={'Números de vía'} title='Números de vía por comunidades autónomas' />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='RestoDireccion' label={'Resto direccion'} title='Resto direcciones por comunidades autónomas' />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='cp' label={'Códigos postales'} title='Códigos postales por comunidades autónomas' />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='provincia' label={'Provincias'} title='Provincias por comunidades autónomas' />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ComunidadesAutonomasField field='municipio' label={'Municipios'} title='Municipios por comunidades autónomas' />
                                            </Grid>
                                        </Grid>
                                        <SecurityTrimmer entity={Entity.Datos} permission={PermissionLevel.Ver}>
                                            <Box className='stepper' sx={{ textAlign: 'right' }}>
                                                <Button variant="text" onClick={() => {
                                                    window.location.href = '/data'
                                                }}>
                                                    VER DATOS
                                                </Button>
                                            </Box>
                                        </SecurityTrimmer>
                                </>
                            )
                        }
                        {
                            total == 0 && (
                                <Card>
                                    <CardContent>
                                        <Alert severity='info' icon={false}>
                                            <Typography variant='h6'>
                                                Sin datos
                                            </Typography>
                                            <Typography variant='body2'>
                                                Aún no se dispone de datos para mostrar la información. 
                                            </Typography>
                                            <Typography variant='body2'>
                                                Cuando se consoliden los datos de alguna normalización, podrás ver aquí el estado de los datos.
                                            </Typography>
                                        </Alert>
                                    </CardContent>
                                </Card>
                            )
                        }
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/data/total`;

        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            let current = 0;

            if (response > 100) {
                current = response - Math.round(response / 10)
            }

            if (response > 1000) {
                current = response - Math.round(response / 100);
            }

            this.setState(
                {
                    total: response
                }
            );
        })
    }
}